export default __webpack_public_path__ + "static/media/6.1352a495.jpg";